export const DEFAULT_ERROR_MESSAGE = 'Error creating TLDL summary';
